// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__1mRgz","shimmer":"styles_shimmer__1gsu7"};